import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 0,
  class: "fs_14 mt-4 d-block text-center error"
}
const _hoisted_6 = {
  type: "submit",
  class: "genericButton bgGradient w-100 mt-5"
}
const _hoisted_7 = { class: "orSeparator" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_social_login = _resolveComponent("social-login")!
  const _component_mandatory_documents = _resolveComponent("mandatory-documents")!
  const _component_val_form = _resolveComponent("val-form")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "backbutton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
    }, [
      _hoisted_2
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "app_bentornato",
      text: "Bentornato",
      class: "fs_28 spaceCadet d-block mt-2"
    }),
    _createVNode(_component_localized_text, {
      localizedKey: "app_accedialtuoaccount",
      text: "Accedi al tuo account",
      class: "fs_16 grey d-block mb-5"
    }),
    _createVNode(_component_val_form, {
      onSubmit: _ctx.doLogin,
      onInvalid: _ctx.doError,
      class: "loginContainer"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("input", {
            type: "email",
            class: "genericInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.username = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.username],
            [_directive_localizedPlaceholder, {key: 'app_email', value: 'Email', afterText : '*'}]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            type: "password",
            class: "genericInput",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.vm.password = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.password],
            [_directive_localizedPlaceholder, {key: 'app_password', value: 'Password', afterText : '*'}]
          ])
        ]),
        _createVNode(_component_router_link, {
          tag: "div",
          to: "/resetpassword",
          class: "fs_13 grey pointer"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: 'app_haidimenticatolapassword?',
              text: 'Hai dimenticato la password?'
            })
          ]),
          _: 1
        }),
        (_ctx.error)
          ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_mini_spinner, {
              key: 1,
              cssClass: 'my-5'
            }))
          : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _createVNode("button", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_login",
                  text: "Login",
                  class: "fs_14 white"
                })
              ]),
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_oAccediCon",
                  text: "o accedi con",
                  class: "fs_16 grey"
                })
              ]),
              _createVNode(_component_social_login),
              _createVNode(_component_mandatory_documents, { documents: _ctx.documents }, null, 8, ["documents"])
            ], 64))
      ]),
      _: 1
    }, 8, ["onSubmit", "onInvalid"])
  ]))
}